<template>

<div>
<template v-if="data.read_only_state">
    {{inputdata}}
  </template>
  <template v-if="!data.read_only_state">
    <Textarea v-model="inputdata" :autoResize="true" rows="5" cols="30"  class="w-full p-inputtext-sm mb-0" :class="{'p-invalid':char_length_err }" @input="fieldChanged" :disabled="data.submissions.length && data.submissions[0].is_nulled" />
<small  class="p-error pt-2" v-if="char_length_err"> {{char_length_err_message}}</small>
  </template>

</div>

</template>

<script>
export default {

  name: 'LongTextType',
  props:["data"],

  data () {
    return {
    	inputdata:null,
    	intervalobj:null,
      char_length_err:null,
      char_length_err_message:null,
    }
  },
  computed:{
    propdata()
    {
      if(this.data.submissions.length>0)
      {
        let propdata = this.data.submissions[0].submission_text
        return propdata
      }
    }
  },
  watch:{
    propdata(newval)
    {
      this.inputdata = newval
    },

  },
  mounted()
  {
  	
  	if(this.data.submissions.length>0)
  	{
  		this.inputdata = this.data.submissions[0].submission_text
  	}
  },
  methods: {
  	fieldChanged()
  	{
      this.char_length_err = false
      this.char_length_err_message = null
      this.$store.dispatch('evaluation/setActiveInputfield',this.data) 
  		clearInterval(this.intervalobj);
  		this.intervalobj = setInterval(()=>{
  			this.submitInputData()
  		},1000)
  	},
  	submitInputData()
  	{
  		clearInterval(this.intervalobj);
      if(this.data.min_char_length && this.inputdata.length<this.data.min_char_length)
      {
        this.char_length_err = true
        this.char_length_err_message = this.$store.state.languages.lang_phrases.bu_alan_icin_minimum_karakter_sayisi+this.data.min_char_length
        return false
      }

      if(this.data.max_char_length && this.inputdata.length>this.data.max_char_length)
      {
        this.char_length_err = true
        this.char_length_err_message = this.$store.state.languages.lang_phrases.bu_alan_icin_maximum_karakter_sayisi+this.data.max_char_length
        return false
      }
  		let formdata = new FormData()
  		formdata.append("text",this.inputdata)
  		formdata.append("type","text")
  		formdata.append("flowsupplier_id",this.$store.state.evaluation.evaluation.uuid)

  		//return false
  		this.submitInputFieldSubmission(formdata,this.data.id)
  	},
  }
};
</script>

<style lang="css" scoped>
</style>